// semeia-disable-reexport
import Ember from "ember";
const computeKey = key => `${Ember.testing ? "test-wise" : "wise"}:${key}`;
const getItem = key => {
  const result = window.localStorage?.getItem(key);
  return result ? result == "undefined" ? null : result : null;
};
const getItemFromLocalStorage = key => {
  return getItem(computeKey(key));
};
const getItemFromLocalStorageWithoutPrefix = key => {
  return getItem(key);
};
const setItem = (key, value) => {
  window.localStorage?.setItem(key, typeof value === "string" ? value : JSON.stringify(value));
};
const setItemInLocalStorage = (key, value) => {
  setItem(computeKey(key), value);
};
const setItemInLocalStorageWithoutPrefix = (key, value) => {
  setItem(key, value);
};
const removeItemFromLocalStorage = key => {
  window.localStorage?.removeItem(computeKey(key));
};
const getKeysFromLocalStorage = () => {
  return Object.keys(window.localStorage);
};
const isLocalStorageAvailable = () => {
  return Boolean(window.localStorage);
};
export { computeKey, getItemFromLocalStorage, getItemFromLocalStorageWithoutPrefix, getKeysFromLocalStorage, isLocalStorageAvailable, removeItemFromLocalStorage, setItemInLocalStorage, setItemInLocalStorageWithoutPrefix };